import React, {ReactNode, useMemo} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

import {calculateRemSize} from "@pg-design/helpers-css";
import {onDesktop} from "@pg-design/helpers-css/";
import {IButtonRadioListOption, Radio} from "@pg-design/radio-module";
import {MaxValueFieldControlled, RadioGroupControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";
import {BudgetFieldMonthlyDefault, BudgetFieldTotalDefault} from "../../constants/budget_fields_defaults";
import {IBudgetType} from "../../types/IBudgetType";

import * as cns from "./BudgetField.module.css";

interface IProps {
    radioName: string;
    type: "list" | "switch";
    totalInputName: string;
    monthlyInputName: string;
    totalTitleRender?: () => ReactNode;
    monthlyTitleRender?: () => ReactNode;
    totalMax?: number;
    useBudgetDynamicStep?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioClassName?: string;
    radioGroupClassName?: string;
}

const budgetConfig = {
    total: {
        min: 0,
        max: BudgetFieldTotalDefault,
        step: 5000
    },
    monthly: {
        min: 0,
        max: BudgetFieldMonthlyDefault,
        step: 200
    }
};

export function BudgetField(props: IProps) {
    const {radioName, type, totalInputName, totalMax = budgetConfig.total.max, monthlyInputName, totalTitleRender, monthlyTitleRender} = props;

    const budgetType: IBudgetType | undefined = useWatch({name: radioName});
    const currency = getCurrency({currency: props.currency});
    const radioList = useMemo(() => {
        return [
            {
                labelContent: totalTitleRender ? totalTitleRender() : <Text variant="info_txt_1">Kwota maksymalna</Text>,
                value: "total"
            },
            {
                labelContent: monthlyTitleRender ? monthlyTitleRender() : <Text variant="info_txt_1">Rata kredytu</Text>,
                value: "monthly"
            }
        ] as IButtonRadioListOption<IBudgetType>[];
    }, [totalTitleRender, monthlyTitleRender]);

    return (
        <div>
            <RadioGroup
                type={type}
                radioRender={
                    type === "switch"
                        ? undefined
                        : ({name, value, id, isActive, onChange, labelContent, className}) => {
                              return (
                                  <div css={customOption}>
                                      <Radio
                                          name={name}
                                          id={id}
                                          value={value}
                                          isActive={isActive}
                                          onChange={onChange}
                                          labelContent={labelContent}
                                          className={className}
                                      />
                                      {value === "monthly" ? (
                                          <MaxValueFieldControlled
                                              disabled={value !== budgetType}
                                              key="monthly"
                                              name={monthlyInputName}
                                              min={budgetConfig.monthly.min}
                                              max={budgetConfig.monthly.max}
                                              step={budgetConfig.monthly.step}
                                              rightElement={currency}
                                          />
                                      ) : (
                                          <MaxValueFieldControlled
                                              disabled={value !== budgetType}
                                              key="total"
                                              name={totalInputName}
                                              min={budgetConfig.total.min}
                                              max={totalMax}
                                              step={budgetConfig.total.step}
                                              rightElement={currency}
                                              isDynamicStep={props.useBudgetDynamicStep}
                                          />
                                      )}
                                  </div>
                              );
                          }
                }
                name={radioName}
                options={radioList}
                className={classNames(props.radioGroupClassName)}
                optionClassName={classNames(cns.budgetFieldOption, props.radioClassName)}
            />
            {type === "switch" && (
                <div css={inputsSwitch}>
                    {budgetType === "total" ? (
                        <MaxValueFieldControlled
                            key="total"
                            name={totalInputName}
                            min={budgetConfig.total.min}
                            max={totalMax}
                            step={budgetConfig.total.step}
                            rightElement={currency}
                            isDynamicStep={props.useBudgetDynamicStep}
                            inputVariant={props.inputVariant}
                        />
                    ) : (
                        <MaxValueFieldControlled
                            key="monthly"
                            name={monthlyInputName}
                            min={budgetConfig.monthly.min}
                            max={budgetConfig.monthly.max}
                            step={budgetConfig.monthly.step}
                            rightElement={currency}
                            inputVariant={props.inputVariant}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

const RadioGroup = styled(RadioGroupControlled)<{type: IProps["type"]}>`
    display: flex;
    min-width: 300px;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        gap: ${calculateRemSize(4)};
    `)}

    ${({type}) =>
        type === "list"
            ? css`
                  flex-direction: column;
              `
            : css`
                  margin: 0 0 ${calculateRemSize(2)} 0;
              `}
`;

const customOption = css`
    min-width: 300px;
`;

const inputsSwitch = css`
    justify-content: center;
`;
import React, {ReactNode, useMemo} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

import {calculateRemSize} from "@pg-design/helpers-css";
import {onDesktop} from "@pg-design/helpers-css/";
import {IButtonRadioListOption, Radio} from "@pg-design/radio-module";
import {MaxValueFieldControlled, RadioGroupControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";
import {BudgetFieldMonthlyDefault, BudgetFieldTotalDefault} from "../../constants/budget_fields_defaults";
import {IBudgetType} from "../../types/IBudgetType";

import * as cns from "./BudgetField.module.css";

interface IProps {
    radioName: string;
    type: "list" | "switch";
    totalInputName: string;
    monthlyInputName: string;
    totalTitleRender?: () => ReactNode;
    monthlyTitleRender?: () => ReactNode;
    totalMax?: number;
    useBudgetDynamicStep?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioClassName?: string;
    radioGroupClassName?: string;
}

const budgetConfig = {
    total: {
        min: 0,
        max: BudgetFieldTotalDefault,
        step: 5000
    },
    monthly: {
        min: 0,
        max: BudgetFieldMonthlyDefault,
        step: 200
    }
};

export function BudgetField(props: IProps) {
    const {radioName, type, totalInputName, totalMax = budgetConfig.total.max, monthlyInputName, totalTitleRender, monthlyTitleRender} = props;

    const budgetType: IBudgetType | undefined = useWatch({name: radioName});
    const currency = getCurrency({currency: props.currency});
    const radioList = useMemo(() => {
        return [
            {
                labelContent: totalTitleRender ? totalTitleRender() : <Text variant="info_txt_1">Kwota maksymalna</Text>,
                value: "total"
            },
            {
                labelContent: monthlyTitleRender ? monthlyTitleRender() : <Text variant="info_txt_1">Rata kredytu</Text>,
                value: "monthly"
            }
        ] as IButtonRadioListOption<IBudgetType>[];
    }, [totalTitleRender, monthlyTitleRender]);

    return (
        <div>
            <RadioGroup
                type={type}
                radioRender={
                    type === "switch"
                        ? undefined
                        : ({name, value, id, isActive, onChange, labelContent, className}) => {
                              return (
                                  <div css={customOption}>
                                      <Radio
                                          name={name}
                                          id={id}
                                          value={value}
                                          isActive={isActive}
                                          onChange={onChange}
                                          labelContent={labelContent}
                                          className={className}
                                      />
                                      {value === "monthly" ? (
                                          <MaxValueFieldControlled
                                              disabled={value !== budgetType}
                                              key="monthly"
                                              name={monthlyInputName}
                                              min={budgetConfig.monthly.min}
                                              max={budgetConfig.monthly.max}
                                              step={budgetConfig.monthly.step}
                                              rightElement={currency}
                                          />
                                      ) : (
                                          <MaxValueFieldControlled
                                              disabled={value !== budgetType}
                                              key="total"
                                              name={totalInputName}
                                              min={budgetConfig.total.min}
                                              max={totalMax}
                                              step={budgetConfig.total.step}
                                              rightElement={currency}
                                              isDynamicStep={props.useBudgetDynamicStep}
                                          />
                                      )}
                                  </div>
                              );
                          }
                }
                name={radioName}
                options={radioList}
                className={classNames(props.radioGroupClassName)}
                optionClassName={classNames(cns.budgetFieldOption, props.radioClassName)}
            />
            {type === "switch" && (
                <div css={inputsSwitch}>
                    {budgetType === "total" ? (
                        <MaxValueFieldControlled
                            key="total"
                            name={totalInputName}
                            min={budgetConfig.total.min}
                            max={totalMax}
                            step={budgetConfig.total.step}
                            rightElement={currency}
                            isDynamicStep={props.useBudgetDynamicStep}
                            inputVariant={props.inputVariant}
                        />
                    ) : (
                        <MaxValueFieldControlled
                            key="monthly"
                            name={monthlyInputName}
                            min={budgetConfig.monthly.min}
                            max={budgetConfig.monthly.max}
                            step={budgetConfig.monthly.step}
                            rightElement={currency}
                            inputVariant={props.inputVariant}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

const RadioGroup = styled(RadioGroupControlled)<{type: IProps["type"]}>`
    display: flex;
    min-width: 300px;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        gap: ${calculateRemSize(4)};
    `)}

    ${({type}) =>
        type === "list"
            ? css`
                  flex-direction: column;
              `
            : css`
                  margin: 0 0 ${calculateRemSize(2)} 0;
              `}
`;

const customOption = css`
    min-width: 300px;
`;

const inputsSwitch = css`
    justify-content: center;
`;
